import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api, { fileUrl } from "@/lib/api";
import { Users, Mail } from "lucide-react";

export default function MembersPage() {
  const { t } = useTranslation();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/members").then((r) => setMembers(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="members-page" className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
      <div className="text-xs uppercase tracking-[0.3em] text-bordeaux-accent mb-4">{t("members.eyebrow")}</div>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900 mb-12">
        {t("members.title")}
      </h1>

      {loading ? (
        <div className="text-slate-500 text-sm">{t("common.loading")}</div>
      ) : members.length === 0 ? (
        <div className="border border-dashed border-slate-200 rounded-sm py-20 text-center text-slate-500">
          <Users className="mx-auto mb-3" size={24} />
          {t("members.empty")}
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {members.map((m) => (
            <div
              key={m.id}
              data-testid={`member-card-${m.id}`}
              className="bg-white border border-slate-200 rounded-sm overflow-hidden hover:border-bordeaux transition-colors"
            >
              <div className="aspect-square bg-beige overflow-hidden">
                {m.image_path ? (
                  <img src={fileUrl(m.image_path)} alt={m.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full grid place-items-center text-slate-400">
                    <Users size={32} />
                  </div>
                )}
              </div>
              <div className="p-6">
                <div className="text-xs uppercase tracking-widest text-bordeaux-accent mb-1.5">{m.position}</div>
                <h3 className="text-xl font-semibold text-slate-900">{m.name}</h3>
                {m.bio && <p className="text-sm text-slate-600 mt-3 leading-relaxed line-clamp-4">{m.bio}</p>}
                {m.email && (
                  <a
                    href={`mailto:${m.email}`}
                    className="inline-flex items-center gap-2 text-sm text-bordeaux mt-4 hover:underline"
                  >
                    <Mail size={14} /> {m.email}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
